import { Component } from '@angular/core';
import { AuthService } from './global-services/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent {
    title = 'app';

    constructor(private authService: AuthService) {
        this.authService.isAuthenticated$.pipe().subscribe((res) => {});

        if (window.matchMedia('(display-mode: standalone)').matches) {
            this.authService.setPwaState(true);
        }
    }
}
